import { render } from "./PlayByPlayGrid.vue?vue&type=template&id=836b0f14&scoped=true"
import script from "./PlayByPlayGrid.vue?vue&type=script&lang=js"
export * from "./PlayByPlayGrid.vue?vue&type=script&lang=js"

import "./PlayByPlayGrid.vue?vue&type=style&index=0&id=836b0f14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836b0f14"]])

export default __exports__